import type { Dictionnaire } from '../type';

export const composants: Dictionnaire['composants'] = {
  champ: {
    masquer: 'Hide password',
    afficher: 'Show password',
    effacer: 'Clear search',
  },
  badge: {
    officiel: 'Official Sirocco account',
    verifie: 'Verified account',
  },
  bulleAppel: {
    revenir: (nom: string) => `Back to the call with ${nom}`,
  },
  etat: {
    annule: 'Canceled: not enough participants',
    confirme: 'Confirmed',
    spontanee: 'Spontaneous',
    enLigne: 'Online',
    seuil: (n: number) => `(min. ${n})`,
  },
  vocal: {
    pause: 'Pause',
    ecouter: 'Play voice message',
    apercu: (duree: string) => `Voice message, ${duree}`,
  },
  onglets: {
    messages: 'Messages',
    evenements: 'Events',
    feed: 'Feed',
    lieux: 'Places',
    profil: 'Profile',
    annuaire: 'Directory',
  },
  barre: {
    navigation: 'Main navigation',
    aRegarder: (onglet: string, n: number) => `${onglet} · ${n} to check`,
  },
  photo: {
    pasOuverte: "This image couldn't be opened",
    pasPreparee: "This photo couldn't be prepared",
    recadrer: 'Crop photo',
    annuler: 'Cancel',
    choisir: 'Choose',
  },
  fichier: {
    pasAjoute: "This file couldn't be added",
  },
  scanner: {
    sansCamera: "Sirocco can't access the camera. You can tick attendance by hand.",
  },
  partage: {
    pasParti: "The share didn't go through.",
    lienCopie: 'Link copied.',
    impossible: "Sharing isn't available in this browser.",
    copieImpossible: "Copying isn't available in this browser.",
    titre: 'Share',
    chercher: 'Search for a friend or a group',
    unInstant: 'One moment…',
    sansCible: 'Add friends or create a group to share without leaving Sirocco.',
    aucun: 'No matching name.',
    envoi: 'Sending…',
    ailleurs: 'Share elsewhere',
    copier: 'Copy link',
    envoyeA: (nom: string) => `Sent to ${nom}.`,
  },
  image: {
    pasUneImage: "This file isn't an image",
    navigateur: "Your browser can't prepare this image",
    tropLourde: 'This image is too large, try another one',
    pasOuverte: "This image couldn't be opened",
  },
  video: {
    tropLourde: (mo: number) =>
    `This video is too large: ${mo} MB, for a maximum of 25. Film it in normal quality rather than 4K.`,
    tropLongue: (secondes: number) => `Fifteen seconds maximum. This one is ${secondes}.`,
  },
  voix: {
    appareil: "Your device can't record voice messages",
    micro: "Sirocco can't access the microphone. Allow it in Settings.",
    interrompu: 'The recording stopped',
    tropCourt: 'Too short. Keep your finger down a little longer.',
    tropLong: 'Voice message too long to send',
    illisible: 'Unreadable recording',
  },
  itineraire: {
    plans: 'Maps',
  },
  billet: {
    monBillet: 'My ticket',
  },
  emojis: {
    smileys: 'Smileys',
    gestes: 'Gestures',
    coeurs: 'Hearts',
    animaux: 'Animals',
    nourriture: 'Food',
    sports: 'Sports',
    voyages: 'Travel',
    objets: 'Objects',
    symboles: 'Symbols',
  },
};
